/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Catering_AllowedInputs */

const en_field_catering_allowed = /** @type {(inputs: Field_Catering_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catering Allowed?`)
};

const es_field_catering_allowed = /** @type {(inputs: Field_Catering_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Se permite catering?`)
};

const fr_field_catering_allowed = /** @type {(inputs: Field_Catering_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restauration autorisée ?`)
};

const de_field_catering_allowed = /** @type {(inputs: Field_Catering_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catering erlaubt?`)
};

const ja_field_catering_allowed = /** @type {(inputs: Field_Catering_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ケータリングの可否`)
};

const zh_field_catering_allowed = /** @type {(inputs: Field_Catering_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`允许提供餐饮服务？`)
};

const ar_field_catering_allowed = /** @type {(inputs: Field_Catering_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يسمح بتقديم الطعام (Catering)؟`)
};

const id_field_catering_allowed = /** @type {(inputs: Field_Catering_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boleh Katering?`)
};

const it_field_catering_allowed = /** @type {(inputs: Field_Catering_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catering Consentito?`)
};

const ru_field_catering_allowed = /** @type {(inputs: Field_Catering_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кейтеринг разрешен?`)
};

const pt_field_catering_allowed = /** @type {(inputs: Field_Catering_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catering Permitido?`)
};

const ko_field_catering_allowed = /** @type {(inputs: Field_Catering_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`케이터링 허용 여부`)
};

/**
* | output |
* | --- |
* | "Catering Allowed?" |
*
* @param {Field_Catering_AllowedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_catering_allowed = /** @type {((inputs?: Field_Catering_AllowedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Catering_AllowedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_catering_allowed(inputs)
	if (locale === "es") return es_field_catering_allowed(inputs)
	if (locale === "fr") return fr_field_catering_allowed(inputs)
	if (locale === "de") return de_field_catering_allowed(inputs)
	if (locale === "ja") return ja_field_catering_allowed(inputs)
	if (locale === "zh") return zh_field_catering_allowed(inputs)
	if (locale === "ar") return ar_field_catering_allowed(inputs)
	if (locale === "id") return id_field_catering_allowed(inputs)
	if (locale === "it") return it_field_catering_allowed(inputs)
	if (locale === "ru") return ru_field_catering_allowed(inputs)
	if (locale === "pt") return pt_field_catering_allowed(inputs)
	return ko_field_catering_allowed(inputs)
});